<template>
  <v-row>
    <v-col>
      <v-sheet
        outlined
        v-if="!loading">
        
        <!-- Imagen para pantallas pequeñas (xs) -->
        <v-img
          class="image-landing"
          height="80"
          v-if="$vuetify.breakpoint.xsOnly && about_jije_sm_image"
          :src="about_jije_sm_image"
          max-height="80px"
        ></v-img>

        <!-- Imagen para pantallas medianas y grandes (md y superiores) -->
        <v-img
          class="image-landing"
          height="120"
          v-if="!$vuetify.breakpoint.xsOnly && about_jije_image"
          :src="about_jije_image"
          max-height="120px"
        ></v-img>

        <v-row class="pa-6">
          <v-col cols="12">
            <h3 class="pb-4">Acerca de JIJE UNL:</h3>  

            <div v-html="parsedText"></div>

            <h3
              v-if="admins.length>0"
              class="pb-4 pt-8">Organizadores:
            </h3>
            <v-row>
              <v-col cols="12" xl="3" md="3" sm="12" v-for="admin in admins" :key="admin.id">
                - {{ admin.lastname.toUpperCase() +', '+ admin.name }}
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'

  export default {
    name: 'About',

    data: () => ({
      loading:true,
      about: '',
      organizers:[],
      admins: [],
      about_jije_image: null,
      about_jije_sm_image: null
    }),
    computed: {
      ...mapGetters([
        'edition'
      ]),
      parsedText() {
        return this.about
          .replace(/ql-align-center/g, 'text-center')
          .replace(/ql-align-right/g, 'text-right')
          .replace(/ql-align-left/g, 'text-left')
          .replace(/ql-align-justify/g, 'text-justify');
      }
    },
    methods:{
      setData(){
        if(this.edition.edition.edition_customization.about_jije_image!=null){
          this.about_jije_image = APP_URL + this.edition.edition.edition_customization.about_jije_image
        }

        if(this.edition.edition.edition_customization.about_jije_sm_image!=null){
          this.about_jije_sm_image = APP_URL + this.edition.edition.edition_customization.about_jije_sm_image
        }
      },

      async getInfo()
      {
        await axios.get('participant/about/'+this.edition.edition.id).then(response =>{
          this.admins = response.data.data.edition_organizers
          this.about =  response.data.data.about.about
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      Promise.all([
        this.setData(),
        this.getInfo()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.image-landing{
	position: relative;
	max-width: 100vw;
	width: 100%;
  border-bottom: 4px solid #00a1b8;
}
</style>